angular.module('bribac.views.singleAgent', [
  'ngRoute',
  'bribac.values',
  'bribac.entities.kinds',
  'bribac.services.routeAuth',
  'bribac.services.api',
  'bribac.services.newMessageEditorModal',
  'bribac.components.whenLoaded',
  'bribac.components.agentDetails'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/agent/:id', {
      templateUrl: 'single-agent-view.html',
      controller: 'SingleAgentViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}}
    })
  })

  .controller('SingleAgentViewCtrl', function(
    $routeParams,
    state,
    KINDS,
    api,
    newMessageEditorModal,
    $uibModal,
    permissions
  ) {

    var $ctrl = this

    $ctrl.KINDS = KINDS
    $ctrl.permissions = permissions

    var agentId = $routeParams.id

    if (agentId === 'me') {
      agentId = state.currentAgent.id
    } else {
      agentId = parseInt(agentId)
    }

    $ctrl.isCurrentAgent = agentId === state.currentAgent.id

    if (!isFinite(agentId)) {
      // TODO: Should show 404 error instead. Should probably do this check in the $routeProvider config.
      return
    }

    $ctrl.activation = function() {
      if ($ctrl.activating) {
        return
      }

      $ctrl.activating = true
      $ctrl.immediateTestSuccessI18n = ''

      var data = angular.extend({}, $ctrl.agent);
      data.accountLocked = !$ctrl.agent.accountLocked

      api['put'](KINDS.AGENT, data)
        .finally(function() {
          $ctrl.activating = false
        })
        .then(
          function success(request) {
            getAgentView()
          },
          function error(request) {
            $ctrl.activationErrorI18n = (request.data && request.data.errorMessage)
              ? request.data.errorMessage
              : (request.statusText || 'Unknown error')
          }
        )
    }

    $ctrl.deleteAgent = function() {
      $ctrl.activating = true;
      if (confirm('Are you sure you want to delete this agent?')) {
        var data = angular.extend({}, $ctrl.agent);
        data.isDeleted = true
        api.put(KINDS.AGENT, data)
          .then(function() {
            $uibModal.open({
              windowClass: 'modal-success',
              template: '<div class="modal-body">Agent ' +
                ($ctrl.agent.fullName || ($ctrl.agent.firstName + ' ' + $ctrl.agent.lastName)) +
                ' (ID: ' + $ctrl.agent.id + ') deleted successfully.</div>',
              size: 'sm'
            });
            setTimeout(function() {
              window.location = '/#!/search';
            }, 2000);
          }, function(error) {
            $uibModal.open({
              windowClass: 'modal-danger',
              template: '<div class="modal-body">Error deleting agent ' +
                ($ctrl.agent.fullName || ($ctrl.agent.firstName + ' ' + $ctrl.agent.lastName)) +
                ' (ID: ' + $ctrl.agent.id + '): ' +
                (error.data && error.data.errorMessage
                  ? error.data.errorMessage
                  : (error.statusText || 'Unknown error')) +
                '</div>',
              size: 'sm'
            });
          });
      }
      $ctrl.activating = false;
    };

    // Init

    $ctrl.agentPromise = api.getView('agent', agentId).then(function(request) {
      $ctrl.agent = request.data
    })

    function getAgentView() {
      api.getView('agent', agentId).then(function(request) {
        $ctrl.agent = request.data
      })
    }

    /*
      Send message.
    */
    $ctrl.newMessageEditorModal = function(agent) {
      newMessageEditorModal(agent, function saveSuccess(message) {
        $ctrl.agent.messages.unshift(message)
      })
    }

    $ctrl.resetPassword = function () {

      $ctrl.actionSuccessI18n = ''
      $ctrl.actionErrorI18n = ''

      api.forgotPassword($ctrl.agent.email).then(
        function success(request) {
          $ctrl.actionSuccessI18n = 'views.forgotPassword.resetEmailSentDescription'
        },
        actionErrorCallback
      )
    }

    function actionErrorCallback(request) {
      $ctrl.actionErrorI18n = request.data.translationKey || request.data.statusText || 'Unknown error'
    }

  })
